import React, { useEffect, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { Message } from 'semantic-ui-react';
import { Loading } from 'react-lib/dist/components-es';

function ReadOnlyMapContainer({ location, setMapImage, isBuilding = true, scale = 0 }) {
  const [map, setMap] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLocationDisplayed, setIsLocationDisplayed] = useState(false);
  const [isLayerSet, setIsLayerSet] = useState(false);

  const { t } = useTranslation();

  const mapLoadedCallback = () => {
    setIsLoaded(true);
  };

  const locationDisplayedCallback = () => {
    setIsLocationDisplayed(true);
  };
  const screenshotTaken = screenshot => {
    setMapImage(screenshot.dataUrl);
  };

  const getMapConfig = () => ({
    location: location ? location.locationInfo : null,
    scale,
    onMapLoaded: mapLoadedCallback,
    onLocationDisplayed: locationDisplayedCallback,
    onScreenshotTaken: screenshotTaken,
    sso: 'Keycloak',
  });

  const initMap = () => {
    if (window.CERNMap) {
      const mapObject = new window.CERNMap(
        document.getElementById('buildingMap'),
        window.REACT_APP_GIS_MAP_URL,
        getMapConfig()
      );
      setMap(mapObject);
    }
  };

  useEffect(() => {
    if (map === null) {
      initMap();
    }
  }, [map]);

  useEffect(() => {
    if (isBuilding && isLoaded && isLocationDisplayed && !isLayerSet) {
      map.display({
        layer: window.REACT_APP_GIS_MAP_RISKS_RO_LAYER,
        mapName: 'CERES',
      });
      setMap(map);
      setIsLayerSet(true);
    }
    if (isLayerSet) {
      setTimeout(() => {
        map.takeScreenshot();
      }, 3000);
    }
  }, [isLoaded, isLocationDisplayed, isLayerSet]);

  return (
    <div id="buildingMapContainer">
      <Loading isLoading={!isLoaded && !!window.CERNMap} />
      <div id="buildingMap">
        {!window.CERNMap && <Message color="yellow">{t('map.loading.error')}</Message>}
      </div>
    </div>
  );
}

export default withTranslation()(ReadOnlyMapContainer);
